import type { IconSvgObject } from './types';

const HeadingIcon: IconSvgObject = [
  ["path", { d: "M6 12H17M6 20V4M17 20V4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default HeadingIcon;
